module.exports = __webpack_public_path__ + "img/nigeria-coat-of-arms.ca160be0.jpg";